export const body = document.querySelector("body");
export const masthead = document.querySelector(".masthead");
export const stickyWrap = document.querySelector(".sticky-wrap");
export const toTop = document.querySelector(".to-top");
export const subWraps = document.querySelectorAll(".menu-item-has-children");
export const adminBar = document.querySelector("#wpadminbar");
